import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button } from "primereact/button";

import { useEffect, useState } from "react";
import { IBranchMastDropdown, ICompanyMastDropdown, ISkillCategoriesDropdown, ITeamsDropdown, IUsersDropdown } from "../../../models/IDropdown";
import { ILogin } from "../../../models/Login";
import { Fetch } from "../../../shared/Fetch";
import { JVDate } from "../../../shared/JVDate";
import { JVDropdown } from "../../../shared/JVDropdown";
import { JVCheckbox } from "../../../shared/JVCheckbox";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";


export interface ISkillFilter {
    fromDate?: Date,
    toDate?: Date,
    company?: number | null,
    branch?: number[] | null,
    category?: number | null,
    team?: number | null,
    recruiter?: number | null,
    user_Status?: boolean | null,
    frequency?: number | null
    exclude_From_Report?: boolean | null,
}


export const EmptySkillFilter: ISkillFilter = {
    fromDate: new Date,
    toDate: new Date,
    company: null,
    branch: null,
    category: null,
    team: null,
    recruiter: null,
    user_Status: null,
    frequency: null,
    exclude_From_Report: null,

}

interface IFilterProps {
    skillFilter: ISkillFilter,
    setSkillFilter: (skillFilter: ISkillFilter) => void,
    onSearch: () => void;

}

const schema = yup.object({
    fromDate: yup.date().nullable(),
    toDate: yup.date().nullable(),
    company: yup.number().nullable(),
    branch: yup.number().nullable(),
    category: yup.number().nullable(),
    recruiter: yup.number().nullable()
});

export const Filter = (props: IFilterProps) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [skillCategories, setSkillCategories] = useState<Array<ISkillCategoriesDropdown>>();
    const [team, setTeam] = useState<Array<ITeamsDropdown>>();
    const [recruiters, setRecruiters] = useState<Array<IUsersDropdown>>();
    const [excel, setExcel] = useState<boolean>(false);
    const [excelNum, setExcelNum] = useState<number | null>(null);
    const [selectedBranch, setSelectedBranch] = useState<Array<number>>([]);
    const [selectedTeam, setSelectTeam] = useState<any | null>(null);
    const [selectedRecruiter, setSelectedRecruiter] = useState<any | null>(null);



    const { control, handleSubmit, reset, watch } = useForm<ISkillFilter>({
        defaultValues: props.skillFilter,
        resolver: yupResolver(schema),
        shouldFocusError: false
    });

    const recruiter_Status = [
        { label: "-- SELECT --", status: null },
        { label: 'Active', status: true },
        { label: 'Inactive', status: false },
    ]


    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const loadSkillCategories = async () => {
        const response = await Fetch("Dropdown/skillsCategories", "GET", null, null, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            const emptyData = {
                req_CategoryID: 0,
                req_CategoryName: "-- SELECT --",
            };
            data.unshift(emptyData);
            setSkillCategories(data);
        }
    };

    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        let endPoint = loginObj.id === 1346 ? "allBranches" : "reqBranchList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    };

    const loadCompanies = async () => {
        let endPoint = loginObj.id === 1346 ? "company" : "reqCompanyList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    };

    const loadTeam = async (branch: number[] | null | undefined, company: number | null | undefined, type?: string) => {
        let queryParameter = null;
        if (branch && branch.length > 0 && branch[0] != 0) {
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");

        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        if (type && type != "" && type != "-- SELECT --") {
            if (type === "sales") queryParameter = "user_Type=sales&" + queryParameter;
            if (type === "recruiter") queryParameter = "user_Type=recruiter&" + queryParameter;
        }

        const response = await Fetch("Dropdown/filterTeamsBranchList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<ITeamsDropdown> = await response.json();
            const emptyData = {
                team_ID: 0,
                team_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setTeam(data);
        }
    }
    const loadRecruiters = async (branch: number[] | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch && branch.length > 0 && branch[0] != 0) {
            // queryParameter = `branch_ID=${branch}`;
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");

        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersListss", "GET", null, `user_Type=recruiter&${queryParameter}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setRecruiters(data);
        }
    }

    const searchToDB = async (body: ISkillFilter) => {
        let filterData: any = body;
        let emptyFilter: any = EmptySkillFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setSkillFilter(body);
    }

    const onSubmit = (data: ISkillFilter) => {
        delete data.frequency;
        if (selectedBranch.length > 0) {
            data.branch = selectedBranch
        }
        searchToDB(data);
        props.onSearch();
    };


    const Clear = () => {
        reset(EmptySkillFilter);
        loadRecruiters([], 0, 0);
        loadTeam([], 0, "");
        loadBranches();
        loadCompanies();
        setExcel(false);
        setExcelNum(null);
        setSelectedBranch([]);
        setSelectedRecruiter(null);
        setSelectTeam(null);
    };

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company") {
                if (value.company != 0 && value.company != null) {
                    loadTeam([], value.company);
                    loadRecruiters([], value.company, 0);
                    loadBranches(value.company);
                } else {
                    if (value.company === 0 && value.company != null) {
                        loadBranches();
                        loadTeam(control._formValues.branch, value.company);
                        loadRecruiters(control._formValues.branch, value.company, control._formValues.team);
                    }
                }
            }

            if (name === "branch") {
                if (selectedBranch.length > 0 && value.branch != null) {
                    loadTeam([], 0);
                    loadRecruiters([], 0, 0);
                } else {
                    if (selectedBranch.length > 0 && value.branch != null) {
                        loadTeam([], control._formValues.company);
                        loadRecruiters([], control._formValues.company, control._formValues.team);
                    }
                }
            }

            if (name === "team") {
                if (value.team != 0 && value.team != null) {
                    loadRecruiters([], 0, value.team);
                } else {
                    if (value.team === 0 && value.team != null) {
                        loadRecruiters(control._formValues.branch, control._formValues.company, value.team);
                    }
                }
            }

            if (name === "frequency") {
                if (value.frequency != 0 && value.frequency != null) {
                    setExcelNum(prev => prev = value?.frequency || 0);
                    setExcel(prev => prev = true);
                } else {
                    setExcel(prev => prev = false);
                    setExcelNum(prev => prev = null);
                }
            }



        });

        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        loadTeam([], 0);
        loadRecruiters([], 0, 0);
        loadCompanies();
        loadBranches();
        loadSkillCategories();
    }, []);

    useEffect(() => {
        if (selectedBranch.length > 0) {
            loadTeam(selectedBranch, 0);
            loadRecruiters(selectedBranch, 0, 0);
        }
    }, [selectedBranch]);

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
            <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" />
            <JVDropdown column={6} label="Company" control={control} name="company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
            {/* <JVDropdown column={6} label="Branch" control={control} name="branch" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" /> */}
            <div className="field col-2 md:col-2">
                <p>Branch</p>
                <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={selectedBranch} onChange={(e) => setSelectedBranch(e.value)} options={branches} optionValue="branch_ID" optionLabel="branchName" display="chip" filter placeholder="Select Branches" />
            </div>
            <div className="field col-2 md:col-2">
                <p>Team</p>
                <Dropdown value={selectedTeam} style={{ height: "37px", marginTop: "-10px" }} onChange={(e) => { setSelectTeam(e.value); }} options={team} optionLabel="team_Name" placeholder="Select Team" optionValue="team_ID" filter />
            </div>
            <div className="field col-2 md:col-2">
                <p>User</p>
                <Dropdown value={selectedRecruiter} style={{ height: "37px", marginTop: "-10px" }} onChange={(e) => { setSelectedRecruiter(e.value); }} options={recruiters} optionLabel="user_Name" placeholder="Select Recruiter" optionValue="login_ID" filter />
            </div>
            {/* <JVDropdown column={6} label="Team" control={control} name="team" options={team} optionLabel="team_Name" optionValue="team_ID" placeholder="Select Team" />
            <JVDropdown column={6} label="User" control={control} name="recruiter" options={recruiters} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" /> */}

            <div style={{ margin: '10px 0', width: '100%' }}></div>

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                {<Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>}
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={Clear} type="button"></Button>
            </div>
        </form>
    );
}